export default (() => {

    let debouncedTimer;

    function debounce(callback, timeout = 500) {
        return function (data) {
            clearTimeout(debouncedTimer);
            debouncedTimer = setTimeout(() => {
                callback(data);
            }, timeout);
        };
    }

    function _debounceSend(request, timeout = 500) {
        return function (data) {
            clearTimeout(debouncedTimer);
            debouncedTimer = setTimeout(() => {
                request.send(data);
            }, timeout);
        };
    }

    function throttle(callback, timeout = 500, runFailSafe) {
        let shouldStop = false,
            failSafeTimer;

        return () => {
            if (shouldStop) {
                return;
            }

            callback();
            shouldStop = true;

            if (runFailSafe) {
                clearTimeout(failSafeTimer);
            }
    
            setTimeout(() => {
                if (runFailSafe) {
                    failSafeTimer = setTimeout(() => {
                        callback();
                    }, timeout);
                }

                shouldStop = false;
            }, timeout);
        };
    }

    function send (config, isDebounced = false) {
        const defaultParameters = {
            contentType: 'application/json',
            method: 'POST'
        };

        config = Object.assign(defaultParameters, config);

        if (config.url === undefined) {
            return wealthify.error.throwError('request.fetch', 'url and data must be defined');
        }

        config.data = JSON.stringify(config.data);

        return new Promise(function (resolve, reject) {
            const request = new XMLHttpRequest();

            request.onload = () => {
                if (request.status >= 200 && request.status < 300) {
                    let data = request.responseText;

                    try {
                        data = JSON.parse(data);
                    } catch {
                        resolve(data);
                    }
                    
                    if (data.success === false) {
                        reject(data);
                    } else {
                        resolve(data);
                    }
                } else {
                    reject({
                        status: request.status,
                        statusText: request.statusText
                    });
                }
            };

            request.onerror = function () {
                reject({
                    status: this.status,
                    statusText: request.statusText
                });
            };
            
            request.open(config.method, config.url, true);

            if (config.ajaxRequest) {
                request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            }

            if (config.antiForgeryToken) {
                request.setRequestHeader('__RequestVerificationToken', config.antiForgeryToken);
            }

            if (config.contentType) {
                request.setRequestHeader('Content-Type', config.contentType);
            }

            if (isDebounced) {
                _debounceSend(request)(config.data);
            } else {
                request.send(config.data);
            }
        }.bind(this));
    }

    function sendAndReplaceDom(config, destination, loadedEvent){
        send(config)
            .then(res => {
                const fragment = document.createRange().createContextualFragment(res);

                destination.replaceChildren(fragment);
                document.dispatchEvent(new Event(loadedEvent));
            })
            .catch(() => {
                const errorElement = wealthify.dom.fromString('<w-callout variant="danger">Something went wrong.</w-callout>');

                destination.replaceChildren(errorElement);
            });
    }

    return {
        debounce,
        send,
        throttle,
        sendAndReplaceDom
    };

})();